import { ZIndex } from 'app/shared/theme/common/typings';

export const zIndex: ZIndex = {
  stageBar: 99, // Must be less than StickyContainer
  imageText: 100,
  floatingButton: 200,
  navbar: 998,
  portalUnderlay: 999,
  drawer: 1000,
  drawerButton: 1001,
  modal: 1002,
  modalButton: 1003,
  snackbar: 1004, // Needs to be higher than modals and their content
  mobileNav: 1005,
  dropdown: 1010,
};
